import { useEffect, useState } from "react";
import Card from "../Card";

const ResutsByRating = (props) => {
  return props.pageToShow === "" ? (
    <p className="fs-3 fw-bolder text-cente mt-5">Nothing to show yet!</p>
  ) : (
    <div className="movies-container my-3 pb-4 container-fluid">
      {props.showMoviesByTitle.length === 0 ? (
        <p className="fs-3 text-center mt-5 fw-bolder">Select some rating!</p>
      ) : (
        props.showMoviesByTitle.map((movie) => {
          return (
            <div className="loaderContainer__search">
              <Card movie={movie} key={movie.id} type="loader_results" />;
            </div>
          );
        })
      )}
    </div>
  );
};

export default ResutsByRating;
